import { useEffect, useState } from "react";
import { api } from "../api/api";
import { ColumnScreenKey, IColumnSettings } from "../types/columnSettings.type";
import {
  filterColumnVisibility,
  getDefaultColumnVisibility,
} from "../constants/columnSettings.constant";

export function useColumnSettings(screenKey: ColumnScreenKey) {
  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    () => getDefaultColumnVisibility(screenKey)
  );
  const [columnSettings, setColumnSettings] = useState<IColumnSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchColumnSettings = async () => {
      setLoading(true);

      try {
        const response = await api.get(`/settings/columns/${screenKey}`);
        const nextSettings = response.data?.columnSettings as IColumnSettings | undefined;

        if (!isMounted || !nextSettings) {
          return;
        }

        setColumnSettings(nextSettings);
        setVisibleColumns(filterColumnVisibility(screenKey, nextSettings.columns));
      } catch (error) {
        if (isMounted) {
          setVisibleColumns(getDefaultColumnVisibility(screenKey));
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchColumnSettings();

    return () => {
      isMounted = false;
    };
  }, [screenKey]);

  return { visibleColumns, columnSettings, loading };
}
